import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { createMarkup } from 'lib/Utils'
import './index.scss'

class Page extends Component {
  // constructor() {
  //   super()
  //   this.state = { someKey: 'someValue' }
  // }

  render () {
    let item = this.props.item
    return (
      <article className='page'>
        <div className='page__content content' dangerouslySetInnerHTML={createMarkup(item.content.rendered)} />
      </article>
    )
  }
}

Page.propTypes = {
  item: PropTypes.object
}

export default Page



// WEBPACK FOOTER //
// ./src/components/Page/index.js